"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var fitter_1 = require("./fitter");

exports.transformFittedPoint = function (fittedPoint, parent, child) {
  var fitMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'fill';
  var left = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '50%';
  var top = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '50%';

  var _fitter_1$fitAndPosit = fitter_1.fitAndPosition(parent, child, fitMode, left, top),
      positionedX = _fitter_1$fitAndPosit.x,
      positionedY = _fitter_1$fitAndPosit.y,
      fittedWidth = _fitter_1$fitAndPosit.width,
      fittedHeight = _fitter_1$fitAndPosit.height;

  var wRatio = child.width / fittedWidth;
  var hRatio = child.height / fittedHeight;
  var x = (fittedPoint.x - positionedX) * wRatio;
  var y = (fittedPoint.y - positionedY) * hRatio;
  var childPoint = {
    x: x,
    y: y
  };
  return childPoint;
};